import { useGT } from 'gt-react';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import { hasMergedDeficit } from '../utils/lineGroups';

const RAIL =
  'ml-1.5 flex min-w-0 items-center gap-1.5 border-l border-border pl-3 text-xs';

/**
 * `SO 81234 · Acme Electric · req 09-12`, indented on the need's rail; a stock
 * line ordered with the need reads `Stock`.
 */
export function SoLineLabel({ line }: { line: AssignmentLine }) {
  const gt = useGT();
  const date = line.triggerSalesOrderRequestedDate;
  if (line.trigger !== 'sales_order') {
    return (
      <span className={RAIL}>
        <span className="shrink-0 text-gray-700">
          {hasMergedDeficit(line)
            ? gt('Stock, added + deficit', {
                context:
                  "buyer board need row child: a buyer-added stock line the engine's min/max deficit merged into",
              })
            : line.trigger === 'manual'
              ? gt('Stock, added', {
                  context:
                    'buyer board need row child: a stock line a buyer added',
                })
              : gt('Stock', {
                  context: 'buyer board need row child: the min/max stock line',
                })}
        </span>
      </span>
    );
  }
  return (
    <span className={RAIL}>
      <span className="shrink-0 font-mono text-gray-700">
        {line.triggerSalesOrderNumber ?? '—'}
      </span>
      {line.triggerSalesOrderCustomerName && (
        <span className="truncate text-muted-foreground">
          · {line.triggerSalesOrderCustomerName}
        </span>
      )}
      {date && (
        <span className="shrink-0 tabular-nums text-muted-foreground">
          ·{' '}
          {gt('req {date}', {
            date: date.slice(5),
            context: 'buyer board SO row, requested date as MM-DD',
          })}
        </span>
      )}
    </span>
  );
}
